export * from './medicin.service';
